import type { MarkRequired } from 'ts-essentials';

import type { BaseOptions, CompatibleStorageValue } from './types';
import { getValueForKey, migrateValue } from './utils';

interface InitStateValueOptions<
  T extends CompatibleStorageValue,
  PersistedParsedValue extends CompatibleStorageValue,
> extends MarkRequired<
    BaseOptions<T, PersistedParsedValue>,
    'migrationStrategy' | 'transformValueOnRead'
  > {
  whenRef: React.MutableRefObject<boolean>;
  emptyValue: T;
  unversionedKey: string;
}

export function initStateValue<
  T extends CompatibleStorageValue,
  PersistedParsedValue extends CompatibleStorageValue,
>({
  unversionedKey,
  version,
  duration,
  parse,
  stringify,
  migrationStrategy,
  emptyValue,
  transformValueOnRead,
  whenRef,
}: InitStateValueOptions<T, PersistedParsedValue>) {
  const valueFromStorage = getValueForKey<PersistedParsedValue>({
    unversionedKey,
    version,
    duration,
    parse,
    stringify,
  });
  const migratedValue =
    valueFromStorage === null
      ? emptyValue
      : migrateValue({
          value: transformValueOnRead(valueFromStorage),
          emptyValue,
          migrationStrategy,
        });

  const parsedValue = whenRef.current ? migratedValue : emptyValue;

  return parsedValue;
}
